import { applyMiddleware, combineReducers, createStore, compose } from 'redux'
import thunk from 'redux-thunk'

import { createBrowserHistory } from 'history'
import {
  routerMiddleware,
  connectRouter,
  RouterState,
} from 'connected-react-router'
import { loadingReducer, LoadingState } from './loading'
import { uiReducer, UiState } from './ui'

// TODO jak się da to zrezygnować z tego i umieścić pod subdomena tą app a nie w /forms/
export const history = createBrowserHistory({ basename: '/public-app/' })

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),

    loading: loadingReducer,
    ui: uiReducer,
  })

export interface RootState {
  router: RouterState

  loading: LoadingState
  ui: UiState
}

export interface Action {
  type: string
  payload: any
}

const composeEnhancer: typeof compose =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const store = createStore(
  createRootReducer(history),
  composeEnhancer(applyMiddleware(routerMiddleware(history), thunk)),
)
